import { useFragment } from 'react-relay';
import { compositionChartFragment } from './CompositionChart.relay';
import HorizontalBarChart from './charts/horizontalBarChart';
import type { CompositionChartProps } from './types';

export const CompositionChart: React.FC<CompositionChartProps> = ({ component, location }) => {
  const data = useFragment(compositionChartFragment, component);

  return (
    <div className="compositionChart w-[1000px]">
      <HorizontalBarChart language={location?.state?.language} data={data.data} />
      {data.disclaimer && <div className="Base-disclaimer disclaimer">{data.disclaimer}</div>}
    </div>
  );
};
